import type {
  VistoriaEtapaDadosPessoais,
  VistoriaEtapaDadosEndereco,
  VistoriaEtapaDadosCnh,
  VistoriaEtapaDadosVeiculo,
  VistoriaEtapaDadosImplementoAgregado,
} from '@/model/vistoria-etapas.interface';
import { isSuppressedValue } from '@/shared/utils/sensitiveData';

// Rascunhos antigos podem conter propriedades de exibição e controle da tela.
// A lista explícita mantém esses campos fora dos payloads de escrita.
const selecionarCampos = <T, K extends keyof T>(dados: T, campos: K[]) => {
  const payload = {} as Partial<Pick<T, K>>;
  for (const campo of campos) {
    // A máscara representa um valor já cadastrado, que deve ser preservado.
    if (dados[campo] !== undefined && !isSuppressedValue(dados[campo])) {
      payload[campo] = dados[campo];
    }
  }
  return payload;
};

export const dadosPessoaisPayload = (dados: VistoriaEtapaDadosPessoais) =>
  selecionarCampos(dados, [
    'idProspect',
    'tipo',
    'email',
    'telefone',
    'celular',
    'rgIe',
    'dataNascimento',
    'representanteLegal',
    'cpfRepresentante',
  ]);

export const dadosEnderecoPayload = (dados: VistoriaEtapaDadosEndereco) =>
  selecionarCampos(dados, [
    'idProspect',
    'cep',
    'endereco',
    'numero',
    'complemento',
    'bairro',
    'cidade',
    'estado',
  ]);

export const normalizarDadosCnh = (dados: VistoriaEtapaDadosCnh) => {
  const payload = { ...dados, naoPossuiCnh: dados.naoPossuiCnh ?? false };
  if (payload.naoPossuiCnh === true) {
    payload.cnh = null;
    payload.catCnh = null;
    payload.dataVencimentoCnh = null;
  }
  return payload;
};

export const dadosCnhPayload = (dados: VistoriaEtapaDadosCnh) =>
  selecionarCampos(normalizarDadosCnh(dados), [
    'idProspect',
    'naoPossuiCnh',
    'cnh',
    'catCnh',
    'dataVencimentoCnh',
  ]);

export const dadosVeiculoPayload = (dados: VistoriaEtapaDadosVeiculo) =>
  selecionarCampos(dados, [
    'idProposta',
    'anoExercicioDut',
    'qtdPortas',
    'cor',
    'combustivel',
    'km',
    'renavam',
    'chassi',
    'quantidadePassageiro',
    'estadoPneu',
    'tipoCambio',
    'numeroMotor',
    'placaSubstituicao',
    'diaVencimentoMensalidade',
  ]);

export const implementoAgregadoPayload = (
  dados: VistoriaEtapaDadosImplementoAgregado,
) =>
  selecionarCampos(
    {
      ...dados,
      observacao: Array.isArray(dados.observacao)
        ? dados.observacao.join('\n')
        : dados.observacao,
    },
    [
      'idPropostaComplemento',
      'descricao',
      'marca',
      'modelo',
      'placa',
      'chassi',
      'observacao',
    ],
  );
